import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=e5371884&scoped=true"
import script from "./StyleGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleGuide.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StyleGuide.vue?vue&type=style&index=0&id=e5371884&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5371884",
  null
  
)

export default component.exports